var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4219 31.2656C11.2031 28.6562 9.78125 24.7969 9.6875 20.4688V19.5312C9.78125 15.2031 11.2188 11.3438 13.4219 8.73438C16.2969 5.01563 20.5156 3.34375 25.2812 3.34375C28.2188 3.34375 30.9844 3.54688 33.3281 5.10938C29.8125 1.9375 25.1719 0.015625 20.0781 0H20C8.95312 0 0 8.95312 0 20C0 30.7188 8.4375 39.4844 19.0469 39.9844C19.3594 40 19.6875 40 20 40C25.125 40 29.7969 38.0781 33.3281 34.9062C30.9844 36.4688 28.375 36.5312 25.4375 36.5312C20.6875 36.5469 16.2812 35 13.4219 31.2656Z",
    fill: "url(#paint0_linear_3283_6935)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4219 8.73438C15.25 6.5625 17.625 5.26563 20.2187 5.26563C26.0469 5.26563 30.7656 11.8594 30.7656 20.0156C30.7656 28.1719 26.0469 34.7656 20.2187 34.7656C17.625 34.7656 15.2656 33.4531 13.4219 31.2969C16.2969 35.0156 20.5625 37.3906 25.3125 37.3906C28.2344 37.3906 30.9844 36.5 33.3281 34.9375C37.4219 31.25 40 25.9219 40 20C40 14.0781 37.4219 8.75 33.3281 5.09375C30.9844 3.53125 28.25 2.64062 25.3125 2.64062C20.5469 2.64062 16.2812 5 13.4219 8.73438Z",
    fill: "url(#paint1_linear_3283_6935)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3283_6935",
    x1: 16.6651,
    y1: 0.652,
    x2: 16.6651,
    y2: 39.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF1B2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4381,
    stopColor: "#FA1A2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5939,
    stopColor: "#ED1528"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#D60E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9272,
    stopColor: "#B70519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A70014"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3283_6935",
    x1: 26.7083,
    y1: 2.93704,
    x2: 26.7083,
    y2: 37.2235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF4B4B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpera);
export default __webpack_public_path__ + "static/media/opera.d51fa907c23b8d07c97c5c1e1e9e65ea.svg";
export { ForwardRef as ReactComponent };